import { render } from "./Create.vue?vue&type=template&id=3cbd1cc0"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3cbd1cc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbd1cc0', script)) {
    api.reload('3cbd1cc0', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=3cbd1cc0", () => {
    api.rerender('3cbd1cc0', render)
  })

}

script.__file = "resources/js/Pages/Station/Create.vue"

export default script